import React from 'react';

interface ContainerPropsInterface {
    children: React.ReactNode;
}

export const Container: React.FC<ContainerPropsInterface> = (props: ContainerPropsInterface) => {
    return <div className="px-small md:mx-auto md:w-full md:max-w-container md:px-medium">{props.children}</div>;
};
